import {
  FIXED_INCENTIVE,
  INCENTIVE_PAID_TO_INSTALLER,
  PRICE_BASED_INCENTIVE,
} from 'resources/incentives/IncentiveConstants'
import { parseIncentiveLibrarySettings } from './incentiveLibrarySettings'
import { isIncentiveCompatibleWithNsp } from './nonSolarIncentiveRules'
import { buildEmptyQuoteIncentive, QuoteIncentiveRow } from './types'

export type IncentiveLibraryRecord = {
  id: number
  url?: string
  title: string
  incentive_type: number
  incentive_paid_to?: number
  settings?: {
    value?: number
    price_based_incentive_type?: QuoteIncentiveRow['settings']['price_based_incentive_type']
  }
  is_archived?: boolean
}

export const filterLibraryIncentivesForNsp = <T extends object>(records: T[], isNsp: boolean): T[] => {
  if (isNsp) {
    return records.filter(isIncentiveCompatibleWithNsp)
  }
  return records.filter((record) => {
    const r = record as IncentiveLibraryRecord
    return (
      !r.is_archived &&
      r.incentive_paid_to === INCENTIVE_PAID_TO_INSTALLER &&
      (r.incentive_type === FIXED_INCENTIVE || r.incentive_type === PRICE_BASED_INCENTIVE)
    )
  })
}

export const excludeAlreadySelectedIncentiveLibraryRows = <T extends { id: number }>(
  records: T[],
  existingLibraryIds: readonly number[]
): T[] => {
  if (!existingLibraryIds.length) return records
  const blocked = new Set(existingLibraryIds)
  return records.filter((record) => !blocked.has(record.id))
}

export const mapIncentiveLibraryRecordToQuoteRow = (record: IncentiveLibraryRecord): QuoteIncentiveRow => {
  const { value, price_based_incentive_type } = parseIncentiveLibrarySettings(record)

  if (record.incentive_type === PRICE_BASED_INCENTIVE) {
    return {
      ...buildEmptyQuoteIncentive(),
      incentive_id: record.id,
      incentive_type: PRICE_BASED_INCENTIVE,
      title: record.title,
      inc_tax: null,
      settings: {
        value,
        price_based_incentive_type,
      },
    }
  }

  return {
    ...buildEmptyQuoteIncentive(),
    incentive_id: record.id,
    incentive_type: FIXED_INCENTIVE,
    title: record.title,
    inc_tax: value,
    settings: {
      value,
      price_based_incentive_type,
    },
  }
}

